"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SliderLabelMixin = require("../../mixins/components/SliderLabelMixin");
/**
 * Used by the `Slider` component to label the slider thumb.
 *
 * @since 6.12.0
 */
var SliderLabel = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "SliderLabel",
  componentId: "c11n-8-107-0__sc-jif7bv-0"
})(["", ""], _SliderLabelMixin.SliderLabelMixin);
exports.SliderLabel = SliderLabel;
SliderLabel.displayName = 'SliderLabel';

/** @component */